import {authenticateUser, getUserPremiumLevel} from '@Libraries/user.library';
import {AuthContext} from '@Libraries/login-signup-library';

window.PMW.mergePMW(window.PMW, {
  /**
   * Shows the login modal if user is not logged in
   * @param {function} [onUserLoggedIn] callback that fires if user is logged in or logs in from the login modal that appears
   * @param {function} [onModalClose] callback that fires on modal close
   * @param {Object} [additionalParams]
   * @returns {Object}
   */
  authenticateUser(onUserLoggedIn = $.noop, onModalClose = $.noop, additionalParams = {}) {
    return authenticateUser(onUserLoggedIn, onModalClose, additionalParams);
  },
  /** The dialog's contexts, for legacy pages that open it through this bridge and cannot import the enum. */
  AUTH_CONTEXT: AuthContext,
  /**
   * Gets the
   * @return {Number}
   */
  getUserPremiumLevel() {
    return getUserPremiumLevel();
  },
});
